import { Helmet } from 'react-helmet-async';

export default function SEO({
  title = "AfriOne BD",
  description = "AfriOne BD",
  ogTitle,
  ogDescription,
  ogImage,
  twitterTitle,
  twitterDescription,
  canonical,
  keywords,
  type = "website",
  // Pages sans intérêt pour la recherche (désinscription, confirmation de
  // paiement) : on demande aux moteurs de ne pas les indexer.
  noindex = false
}) {
  const baseUrl = "https://afrionebd.eu";
  // Une page produit fournit sa propre image ; sinon on retombe sur le visuel du site.
  const shareImage = ogImage || `${baseUrl}/og-image.jpg`;
  const twitterImage = ogImage || `${baseUrl}/twitter-image.jpg`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content="AfriOne BD" />
      {/* Une seule directive robots pour tout le site, décidée ici. */}
      <meta
        name="robots"
        content={noindex
          ? "noindex, follow"
          : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"}
      />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical || baseUrl} />
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={shareImage} />
      <meta property="og:site_name" content="AfriOne BD" />
      <meta property="og:locale" content="fr_BE" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical || baseUrl} />
      <meta name="twitter:title" content={twitterTitle || title} />
      <meta name="twitter:description" content={twitterDescription || description} />
      <meta name="twitter:image" content={twitterImage} />
      
      {/* Canonical */}
      <link rel="canonical" href={canonical || baseUrl} />
    </Helmet>
  );
}
